<template>
    <v-container
        ref="mapContainer"
        style="padding: 16px; margin-top: 5px;"
    >
        <v-row
            style="margin-bottom: -24px !important"
        >
            <v-col sm="2">
                <v-checkbox
                    v-model="renderWorkArea"
                    class="my-0"
                    label="DigSite"
                />
            </v-col>
            <v-col
                sm="2"
            >
                <v-checkbox
                    v-model="renderGrids"
                    class="my-0"
                    label="Grids"
                />
            </v-col>
            <v-col
                cols="4"
            >
                <v-checkbox
                    v-model="renderBoundingBox"
                    class="my-0"
                    label="Extent"
                />
            </v-col>
            <v-col
                cols="4"
                class="mt-0 mb-auto"
                :class="$vuetify.breakpoint.xs ? 'mobile-icons' : ''"
            >
                <v-btn
                    :class="this.$store.getters.forceOffline?'d-none':''"
                    icon
                    style="float:right"
                    @click="openColorsDialog"
                >
                    <ColorIcon />
                </v-btn>
                <v-btn
                    :class="this.$store.getters.forceOffline?'d-none':''"
                    icon
                    style="float:right"
                    @click="openMapLayersDialog"
                >
                    <LayerIcon />
                </v-btn>
                <v-btn
                    :class="this.$store.getters.forceOffline?'d-none':''"
                    :disabled="!this.$store.getters.ticketDetails.Tickets.address_label.length"
                    icon
                    style="float:right"
                    @click="openGoogleMaps"
                >
                    <GoogleIcon />
                </v-btn>
            </v-col>
        </v-row>
        <v-row
            v-if="Object.keys(layerChips).length"
            no-gutters
        >
            <v-chip
                v-for="(item, name) in layerChips"
                :key="name"
                small
                class="mx-2 my-0"
                close
                @click:close="removeLayer(name)"
            >
                {{ item.name }}
            </v-chip>
            <v-chip
                class="pb-2"
                color="primary"
                outlined
                @click="clearLayers"
            >
                Clear
            </v-chip>
            <v-chip
                v-if="currentMapZoom < MIN_ZOOM_FOR_MAP_LAYER_DATA"
                small
                class="mx-2 my-0"
                color="red"
                text-color="yellow"
                style="font-weight: bold;"
            >
                ZOOM IN TO UPDATE LAYER DATA
            </v-chip>
        </v-row>

        <div
            id="map"
            ref="map-root"
            style="height: 70vh; border: 1px solid var(--ll-border); background: var(--ll-surface);"
            :style="{'height': this.$vuetify.breakpoint.xs ? '77vh' : '70vh'}"
            class="mb-2"
        />

        <v-row>
            <v-col
                :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
                :class="[($vuetify.breakpoint.smAndDown ? 'text-center' : '') , (this.$store.getters.forceOffline?'d-none':'')]"
            >
                <v-btn-toggle
                    v-model="toggle_address_parcel"
                >
                    <v-btn
                        v-model="renderAddress"
                        :small="$vuetify.breakpoint.xs"
                        outlined
                        @click="addressParcel('addr')"
                    >
                        Address
                    </v-btn>
                    <v-btn
                        v-model="renderParcel"
                        :small="$vuetify.breakpoint.xs"
                        outlined
                        @click="addressParcel('parcel')"
                    >
                        Parcel
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
        <v-dialog
            v-model="colorsDialog"
            max-width="290"
            persistent
        >
            <v-card>
                <v-card-title class="text-h5">
                    Color Configuration
                </v-card-title>
                <v-card-text>
                    <div>
                        <label>Dig Site</label>
                        <div class="colorBtn">
                            <v-text-field
                                v-model="digSiteColor"
                                hide-details
                                class="configColors"
                                solo
                            >
                                <template v-slot:append>
                                    <v-menu
                                        v-model="digSiteMenu"
                                        top
                                        nudge-bottom="105"
                                        nudge-left="16"
                                        :close-on-content-click="false"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <div
                                                :style="digSiteStyle"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-card>
                                            <v-card-text class="pa-0">
                                                <v-color-picker
                                                    v-model="digSiteColor"
                                                    flat
                                                />
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </div>
                        <label>Grids</label>
                        <div class="colorBtn">
                            <v-text-field
                                v-model="gridColor"
                                hide-details
                                class="configColors"
                                solo
                            >
                                <template v-slot:append>
                                    <v-menu
                                        v-model="gridMenu"
                                        top
                                        nudge-bottom="105"
                                        nudge-left="16"
                                        :close-on-content-click="false"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <div
                                                :style="gridStyle"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-card>
                                            <v-card-text class="pa-0">
                                                <v-color-picker
                                                    v-model="gridColor"
                                                    flat
                                                />
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </div>
                        <label>Best Fit</label>
                        <div class="colorBtn">
                            <v-text-field
                                v-model="bestfitColor"
                                hide-details
                                class="configColors"
                                solo
                            >
                                <template v-slot:append>
                                    <v-menu
                                        v-model="bestfitMenu"
                                        top
                                        nudge-bottom="105"
                                        nudge-left="16"
                                        :close-on-content-click="false"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <div
                                                :style="bestfitStyle"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-card>
                                            <v-card-text class="pa-0">
                                                <v-color-picker
                                                    v-model="bestfitColor"
                                                    flat
                                                />
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </div>
                        <label>Address</label>
                        <div class="colorBtn">
                            <v-text-field
                                v-model="addressColor"
                                hide-details
                                class="configColors"
                                solo
                            >
                                <template v-slot:append>
                                    <v-menu
                                        v-model="addressMenu"
                                        top
                                        nudge-bottom="105"
                                        nudge-left="16"
                                        :close-on-content-click="false"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <div
                                                :style="addressStyle"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-card>
                                            <v-card-text class="pa-0">
                                                <v-color-picker
                                                    v-model="addressColor"
                                                    flat
                                                />
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </div>
                        <label>Parcel</label>
                        <div class="colorBtn">
                            <v-text-field
                                v-model="parcelColor"
                                hide-details
                                class="configColors"
                                solo
                            >
                                <template v-slot:append>
                                    <v-menu
                                        v-model="parcelMenu"
                                        top
                                        nudge-bottom="105"
                                        nudge-left="16"
                                        :close-on-content-click="false"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <div
                                                :style="parcelStyle"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-card>
                                            <v-card-text class="pa-0">
                                                <v-color-picker
                                                    v-model="parcelColor"
                                                    flat
                                                />
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn @click="colorsDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn @click="ApplyColors">
                        Apply
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="layersDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <v-card-title class="text-h5">
                    Map Layers
                </v-card-title>
                <v-card-text>
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Layer
                                    </th>
                                    <th class="text-left">
                                        Color
                                    </th>
                                    <th class="text-left">
                                        Description
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in companyLayersVisible"
                                    :key="item.layer_id"
                                >
                                    <td>
                                        <v-checkbox
                                            v-model="layerCheckbox"
                                            :label="item.name"
                                            :value="item.layer_id"
                                        />
                                    </td>
                                    <td>
                                        <div
                                            class="layerDialogColor"
                                            :style="{
                                                background: item.style.color,
                                                color: item.style.color,
                                            }"
                                        >
                                            &nbsp;
                                        </div>
                                    </td>
                                    <td class="layerDialogText">
                                        {{ item.description }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <template>
                        <v-checkbox
                            v-model="defaultCheckbox"
                            label="Set As Default"
                        />
                    </template>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn @click="layersDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn @click="ApplyLayers">
                        Apply
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ColorIcon from '@/components/CustomIcons/ColorIcon';
import LayerIcon from '@/components/CustomIcons/LayerIcon';
import GoogleIcon from '@/components/CustomIcons/GoogleIcon';
import webtmsBackend from '../../services/webtmsBackend';
import { getOption } from '../../utils/options.js';

import {Style, Stroke, Fill, Text, Circle} from 'ol/style';

import 'ol/ol.css';
import {Map, View, Overlay, Feature, PluggableMap} from 'ol' ;
import * as coordinate from 'ol/coordinate';
import * as control from 'ol/control';
import * as events from 'ol/events';
import * as extent from 'ol/extent';
import * as format from 'ol/format';
import * as geom from 'ol/geom';
import * as interaction from 'ol/interaction';
import * as layer from 'ol/layer';
import * as proj from 'ol/proj';
import * as render from 'ol/render';
import * as reproj from 'ol/reproj';
import * as source from 'ol/source';
import * as sphere from 'ol/sphere';
import * as style from 'ol/style';
import * as tilegrid from 'ol/tilegrid';
import * as webgl from 'ol/webgl';
import * as turf from '@turf/turf';
import * as loadingstrategy from 'ol/loadingstrategy';

import { isTruthy } from '@/utils/isTruthy';
import { guidEqual, guidNormal } from '@/utils/guid.js';

import '@/components/Map/QMOL.css';
import Compass from '@/assets/compass-rose.png';
import Logo from '@/components/Map/QMOL_Logo.png';
import QMOL_Data from '@/components/Map/QMOL_Data.js';
import {quickMap} from '@/components/Map/QMOL.js';

let __LAST_MAP_EXTENT = null;

export default {
    name: 'Map',
    components: {
        ColorIcon,
        LayerIcon,
        GoogleIcon,
    },
    data: () => ({
        qm: null,
        features: {},
        image: {},
        currentMapZoom: 20,
        MIN_ZOOM_FOR_MAP_LAYER_DATA: 11,
        digSiteMenu: false,
        gridMenu: false,
        bestfitMenu: false,
        addressMenu: false,
        parcelMenu: false,
        layerChips: [],
        layerCheckbox: [],
        defaultCheckbox: false,
        mapDir: {
            // used with getMappingDirectory()
            dir: [],
            address: {
                layer: false, // false or string (name of address layer)
                data: [],
            },
            parcel: {
                layer: false, // false or string (name of parcel layer)
                data: [],
            },
        },
        colorsDialog: false,
        layersDialog: false,
        digSiteColor: getOption('UI:TICKET_COLOR_DIGSITE') || '#0000FF',
        gridColor: getOption('UI:TICKET_COLOR_GRID') || '#FFA500',
        bestfitColor: getOption('UI:TICKET_COLOR_BESTFIT') || '#782C9E',
        addressColor: getOption('UI:TICKET_COLOR_ADDRESS') || '#00e1ff',
        parcelColor: getOption('UI:TICKET_COLOR_PARCEL') || '#39f014',
        ticketDetails: {},
        state: '',
        county: '',
        companyCenters: [],
        companyLayersVisible: [],
        toggle_address_parcel: undefined,
        renderAddress: false,
        renderAddressFull: false,
        renderParcel: false,
        forceOffline: false,
    }),
    computed: {
        digSiteStyle() {
            return {
                backgroundColor: this.digSiteColor,
                cursor: 'pointer',
                height: '10px',
                width: '200px',
                borderRadius: '4px',
                transition: 'border-radius 200ms ease-in-out',
            };
        },
        gridStyle() {
            return {
                backgroundColor: this.gridColor,
                cursor: 'pointer',
                height: '10px',
                width: '200px',
                borderRadius: '4px',
                transition: 'border-radius 200ms ease-in-out',
            };
        },
        bestfitStyle() {
            return {
                backgroundColor: this.bestfitColor,
                cursor: 'pointer',
                height: '10px',
                width: '200px',
                borderRadius: '4px',
                transition: 'border-radius 200ms ease-in-out',
            };
        },
        addressStyle() {
            return {
                backgroundColor: this.addressColor,
                cursor: 'pointer',
                height: '10px',
                width: '200px',
                borderRadius: '4px',
                transition: 'border-radius 200ms ease-in-out',
            };
        },
        parcelStyle() {
            return {
                backgroundColor: this.parcelColor,
                cursor: 'pointer',
                height: '10px',
                width: '200px',
                borderRadius: '4px',
                transition: 'border-radius 200ms ease-in-out',
            };
        },
        renderBoundingBox: {
            get() {
                return this.$store.getters.renderBoundingBox;
            },
            set() {
                this.$store.commit('SET_RENDERBOUNDINGBOX', !this.renderBoundingBox);
                this.loadExtent();
            }
        },
        renderWorkArea: {
            get() {
                return this.$store.getters.renderWorkArea; 
            },
            set() {
                this.$store.commit('SET_RENDERWORKAREA', !this.renderWorkArea);
                this.loadWorkArea();
            }
        },
        renderGrids: {
            get() {
                return this.$store.getters.renderGrids;
            },
            set() {
                this.$store.commit('SET_RENDERGRIDS', !this.renderGrids);
                this.loadGrids();
            }
        },
    },
    watch:{
        renderWorkArea: function(){
            this.loadWorkArea();
        },
        renderGrids: function(){
            this.loadGrids();
        },
        renderBoundingBox: function(){
            this.loadExtent();
        },
    },
    mounted() {
        setTimeout(async () => {
            this.qm = new quickMap(
                {
                    ol: {View,Map,Overlay,Feature,PluggableMap,control,coordinate,events,extent,format,geom,interaction,loadingstrategy,layer,proj,render,reproj,source,sphere,style,tilegrid,webgl},
                    turf: turf,
                    target: 'map',
                    compass: Compass,
                    logo: Logo,
                    extraData: QMOL_Data.QMOL_Data,
                    declutter: true,
                }
            );

            this.qm.showDraw=false;
            this.qm.showEdit=false;
            this.qm.showDelete=false;
            this.qm.showBullseye=false;
            this.qm.showWeather=false;

            document.addEventListener('qmolSingleClick', this.onQmolSingleClick);
            document.addEventListener('qmolClear', this.onQmolClear);
            document.addEventListener('qmolMoveEnd', this.onQmolMoveEnd);

            // Add ESRI feature layers
            console.log('mounted::setTimeout::addEsriFeatureLayer');
            console.log('companyLayersVisible', this.companyLayersVisible);
            console.log('layerCheckbox', this.layerCheckbox);
            console.log('chips', this.layerChips);

            await this.AddChips();

        }, 0);

        this.ticketDetails = this.$store.getters.ticketDetails;
        this.state = this.$store.getters.ticketDetails.Tickets.state;
        this.county = this.$store.getters.ticketDetails.Tickets.county;
        this.companyCenters = this.$store.getters.companyCenters;
        this.companyLayersVisible = this.$store.getters.companyLayers.filter((lyr) => {
            if(typeof lyr.style === 'string') {
                lyr.style = JSON.parse(lyr.style);
            }
            lyr.style.color=lyr.style.color||'#808080';
            return isTruthy(lyr.style.show);
        });
        this.forceOffline  = this.$store.getters.forceOffline;

        this.getMappingDirectory (this.state, this.county);
        this.initMapLayerCheckbox();

        setTimeout(() => {
            this.loadWorkArea();
            this.qm.zoomToShow();
            this.initializeMapOptions();
        }, 0);

        if (this.$store.getters.forceOffline){
            this.getOfflineMap();
        }
    },
    beforeDestroy() {
        document.removeEventListener('qmolSingleClick', this.onQmolSingleClick);
        document.removeEventListener('qmolClear', this.onQmolClear);
        document.removeEventListener('qmolMoveEnd', this.onQmolMoveEnd);
    },
    methods: {
        onQmolSingleClick(e) {
            this.singleClick(e);
        },
        onQmolClear() {
            this.qm.clearMeasure();
            this.qm.clearBullseye();
            this.qm.removeFromShow('group','identify');
        },
        onQmolMoveEnd() {
            this.currentMapZoom = Math.floor(this.qm.getMapZoom());
            this.getLayerData();
        },
        async getOfflineMap(){
            this.showfullscreenbutton = false;
            this.showlayerselect = false;
            this.showidentifybutton = false;
            let response = await webtmsBackend.getMapImage(null,null,null,null,null,null,null,null,this.$store.getters);
            if(response.data.indexOf('OK;') === 0){
                const urlExtent = response.data.split(';')[1].split(',');
                this.qm.addToImage(
                    `${response.host}${urlExtent[0]}`,
                    [
                        parseFloat(urlExtent[3]),
                        parseFloat(urlExtent[2]),
                        parseFloat(urlExtent[4]),
                        parseFloat(urlExtent[1])
                    ]
                );
            }
        },
        loadWorkArea(){
            const features = {
                type: 'FeatureCollection',
                features: [],
            };
            if (this.renderWorkArea){
                const strokeColor = this.hexToRGBA(this.digSiteColor,1);
                const fillColor = this.hexToRGBA(this.digSiteColor,0.2);
                for (const poly of this.ticketDetails.Ticket_Polygons) {
                    features.features.push({
                        type: 'Feature',
                        properties: {
                            group: 'workarea',
                            style: function(zoom){
                                return zoom<0?undefined:new Style({
                                    text:new Text({text:zoom<14?'':'Notification Area',font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:-15}),
                                    stroke:new Stroke({color:strokeColor,width:2}),
                                    fill:new Fill({color:fillColor}),
                                });
                            },
                        },
                        geometry: {
                            type: 'Polygon',
                            coordinates: JSON.parse(`[[[${poly.shapestring.replace(/,-/g,'],[-')}]]]`)
                        }
                    });
                }
            }
            this.qm.removeFromShow('group','workarea');
            this.qm.addToShow(features);
        },
        loadGrids(){
            const features = {
                type: 'FeatureCollection',
                features: [],
            };
            if (this.renderGrids){
                const strokeColor = this.hexToRGBA(this.gridColor,1);
                const fillColor = this.hexToRGBA(this.gridColor,0.2);
                for (const grid of this.ticketDetails.Ticket_Grids) {
                    if (grid.shapestring) {
                        // only if it has geometry
                        features.features.push({
                            type: 'Feature',
                            properties: {
                                group: 'grids',
                                style: function(zoom){
                                    return zoom<12?undefined:new Style({
                                        text:new Text({text:zoom<14?'':grid.grid,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:-15}),
                                        stroke:new Stroke({color:strokeColor,width:2}),
                                        fill:new Fill({color:fillColor}),
                                    });
                                },
                            },
                            geometry: {
                                type: 'Polygon',
                                coordinates: JSON.parse(`[[[${grid.shapestring.replace(/,-/g,'],[-')}]]]`)
                            }
                        });
                    }
                }
            }
            this.qm.removeFromShow('group','grids');
            this.qm.addToShow(features);
        },
        loadExtent(){
            const features = {
                type: 'FeatureCollection',
                features: [],
            };
            if (this.renderBoundingBox){
                const extent =
                        '[[[' + this.ticketDetails.Ticket_Status.long_min +
                        ',' +
                        this.ticketDetails.Ticket_Status.lat_min +
                        '],[' +
                        this.ticketDetails.Ticket_Status.long_min +
                        ',' +
                        this.ticketDetails.Ticket_Status.lat_max +
                        '],[' +
                        this.ticketDetails.Ticket_Status.long_max +
                        ',' +
                        this.ticketDetails.Ticket_Status.lat_max +
                        '],[' +
                        this.ticketDetails.Ticket_Status.long_max +
                        ',' +
                        this.ticketDetails.Ticket_Status.lat_min +
                        ']]]';
                const strokeColor = this.hexToRGBA(this.bestfitColor,1);
                const fillColor = this.hexToRGBA(this.bestfitColor,0.2);
                features.features.push({
                    type: 'Feature',
                    properties: {
                        group:'extent',
                        style: function(zoom){
                            return zoom<12?undefined:new Style({
                                text:new Text({text:zoom<14?'':'Notification Extent',font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:-15}),
                                stroke:new Stroke({color:strokeColor,width:2}),
                                fill:new Fill({color:fillColor}),
                            });
                        },
                    },
                    geometry: {
                        type: 'Polygon',
                        coordinates: JSON.parse(extent)
                    }
                });
            }
            this.qm.removeFromShow('group','extent');
            this.qm.addToShow(features);
        },
        hexToRGBA (hex, alpha) {
            return `${hex}${Math.floor(alpha * 255).toString(16).padStart(2, 0)}`;
        },
        initMapLayerCheckbox() {
            console.log('initMapLayerCheckbox()');
            var opt_MAP_LAYERS_SHOW_DEFAULT = (getOption('MAP_LAYERS_SHOW_DEFAULT') || '').toLowerCase();
            for (const layer of this.companyLayersVisible) {
                if (typeof layer.style === 'string') { // comes from server as a JSON string
                    layer.style=JSON.parse(layer.style);
                }
                if (isTruthy(layer.style.show) && opt_MAP_LAYERS_SHOW_DEFAULT.indexOf(guidNormal(layer.layer_id)) > -1) {
                    this.layerCheckbox.push(layer.layer_id);
                }
            }
        },
        removeEsriFeatureLayer(qm, layerUrl) {
            const layers = qm.map.getLayers().getArray();
            for (const layer of layers) {
                if (layer.get('name') === layerUrl) {
                    const source = layer.getSource();
                    if (source) {
                        source.clear(true);
                    }
                    qm.map.removeLayer(layer);
                    qm.map.renderSync();
                    break;
                }
            }
        },
        // Add external ESRI feature layer to map with full pagination to ensure all features are loaded.
        // Fetches layer metadata once to determine objectIdField and maxRecordCount, then pages
        // through all features intersecting the current map extent using bbox loading strategy.
        async addEsriFeatureLayer(qm, layerUrl, apiToken, color, label) {
            color = color ?? '#FF00FF';
            label = label ?? '';

            const minZoom = 14;
            const maxZoom = 24;
            const fontSize = '12px';
            const width = 3;

            const ol = qm.ol;

            // Fetch layer metadata to get objectIdField and maxRecordCount
            let objectIdField = 'OBJECTID';
            let serverPageSize = 1000;
            try {
                const metaUrl = `${layerUrl}?f=json${apiToken ? `&token=${encodeURIComponent(apiToken)}` : ''}`;
                const metaResp = await fetch(metaUrl);
                const meta = await metaResp.json();
                if (meta.objectIdField) objectIdField = meta.objectIdField;
                if (meta.maxRecordCount && meta.maxRecordCount > 0) {
                    serverPageSize = meta.maxRecordCount;
                }
            } catch (e) {
                console.warn('addEsriFeatureLayer: failed to fetch layer metadata, using defaults', e);
            }

            const esriFormat = new ol.format.EsriJSON();

            // Paged loader: fetches all features for the given extent, paging until exhausted
            const loader = async function (extent, resolution, projection, success, failure) {
                const srid = projection.getCode().split(/:(?=\d+$)/).pop();
                const geometryParam = encodeURIComponent(
                    `{"xmin":${extent[0]},"ymin":${extent[1]},"xmax":${extent[2]},"ymax":${extent[3]},"spatialReference":{"wkid":${srid}}}`
                );
                const baseQuery = `${layerUrl}/query/?f=json&returnGeometry=true`
                    + `&spatialRel=esriSpatialRelIntersects`
                    + `&geometry=${geometryParam}`
                    + `&geometryType=esriGeometryEnvelope`
                    + `&inSR=${srid}`
                    + `&outFields=${label ? encodeURIComponent(label) : '*'}`
                    + `&outSR=${srid}`
                    + `&orderByFields=${encodeURIComponent(objectIdField)}`
                    + (apiToken ? `&token=${encodeURIComponent(apiToken)}` : '');

                const source = this;
                const seenIds = new Set();
                let offset = 0;
                let allFeatures = [];

                const maxPages = 50;
                try {
                    for (let page = 0; page < maxPages; page++) {
                        const url = `${baseQuery}&resultOffset=${offset}&resultRecordCount=${serverPageSize}`;
                        const resp = await fetch(url);
                        const json = await resp.json();

                        if (!json.features || json.features.length === 0) break;

                        const page = esriFormat.readFeatures(json, {
                            featureProjection: projection,
                        });

                        // De-duplicate by objectId to guard against overlap between pages
                        const unique = page.filter(f => {
                            const id = f.getId() ?? f.get(objectIdField);
                            if (id != null && seenIds.has(id)) return false;
                            if (id != null) seenIds.add(id);
                            return true;
                        });

                        allFeatures = allFeatures.concat(unique);
                        offset += json.features.length;

                        // Stop when the server signals no more records, or page was smaller than requested
                        if (json.exceededTransferLimit === false || json.features.length < serverPageSize) break;
                        // Also stop if exceededTransferLimit is not present and page is full — continue to be safe
                        if (json.exceededTransferLimit === undefined && json.features.length < serverPageSize) break;
                    }

                    source.addFeatures(allFeatures);
                    success(allFeatures);
                } catch (e) {
                    console.error('addEsriFeatureLayer: error loading features', e);
                    failure();
                }
            };

            const vectorSource = new ol.source.Vector({
                format: esriFormat,
                loader: loader,
                strategy: ol.loadingstrategy.bbox,
            });

            const styleFunction = function (feature) {
                let text = feature.get(label);
                text = text ? text.toString() : '';
                switch (feature.getGeometry().getType()) {
                    case 'Point': case 'MultiPoint':
                        return new ol.style.Style({
                            image: new ol.style.Circle({
                                radius: 5,
                                fill: new ol.style.Fill({ color: color }),
                                stroke: new ol.style.Stroke({ color: color, width: 1 })
                            }),
                            text: new ol.style.Text({
                                text: text,
                                font: `bold italic ${fontSize} sans-serif`,
                                offsetX: 10,
                                textAlign: 'left',
                                fill: new ol.style.Fill({ color: '#000000' }),
                                stroke: new ol.style.Stroke({ color: '#FFFFFF', width: 3 })
                            })
                        });
                    case 'LineString': case 'MultiLineString':
                        return new ol.style.Style({
                            stroke: new ol.style.Stroke({ color: color, width: width }),
                            text: new ol.style.Text({
                                text: text,
                                font: `bold italic ${fontSize} sans-serif`,
                                fill: new ol.style.Fill({ color: '#000000' }),
                                stroke: new ol.style.Stroke({ color: '#FFFFFF', width: 3 }),
                                placement: 'line',
                                overflow: true,
                                maxAngle: Math.PI / 4,
                                offsetY: 10
                            })
                        });
                    case 'Polygon': case 'MultiPolygon':
                        return new ol.style.Style({
                            stroke: new ol.style.Stroke({ color: color, width: width }),
                            fill: new ol.style.Fill({ color: `${color}0F` }),
                            text: new ol.style.Text({
                                text: text,
                                font: `bold italic ${fontSize} sans-serif`,
                                fill: new ol.style.Fill({ color: '#000000' }),
                                stroke: new ol.style.Stroke({ color: '#FFFFFF', width: 3 })
                            })
                        });
                }
            };

            const vector = new ol.layer.Vector({
                name: layerUrl,
                minZoom: Math.max(0, minZoom),
                maxZoom: Math.min(24, maxZoom),
                declutter: true,
                style: styleFunction,
                source: vectorSource,
            });

            this.removeEsriFeatureLayer(this.qm, layerUrl);
            qm.map.addLayer(vector);
        },
        async getMappingDirectory(state, county) {
            // skip if offiline
            if (this.$store.getters.forceOffline) return ;

            // get directory
            let response = await webtmsBackend.getMappingDirectory(
                state,
                county
            );

            // handle response
            if (typeof response === 'string') {
                if (response.startsWith('OK;')) {
                    this.mapDir.dir = response.split(';');
                    this.mapDir.parcel.layer = false;
                    this.mapDir.parcel.data = [];
                    this.mapDir.address.layer = false;
                    this.mapDir.address.data = [];
                    for (const item of this.mapDir.dir) {
                        if (/par[0-9]{5}/.test(item.toLowerCase())) {
                            this.mapDir.parcel.layer = item;
                        }
                        if (
                            /adr[0-9]{5}/.test(item.toLowerCase()) ||
                            /address[0-9]{5}/.test(item.toLowerCase())
                        ) {
                            this.mapDir.address.layer = item;
                        }
                    }
                }
            }
        },
        centerSupportsMapping(center_id) {
            let center = null;
            for (const item of this.companyCenters) {
                if (item.center_id === center_id) {
                    center = item;
                    break;
                }
            }
            if (center) {
                if (center.uses_mapping === true) {
                    return true;
                }
            }
            return false;
        },
        htmlEncode(value) {
            return !value
                ? value
                : String(value)
                    .replace(/&/g, '&amp;')
                    .replace(/>/g, '&gt;')
                    .replace(/</g, '&lt;')
                    .replace(/"/g, '&quot;');
        },
        hexColor2rgba(hexColor, alpha) {
            var defaultColor = function () {
                return 'rgba(192,192,192,0.9)';
            };

            if (!hexColor || !hexColor.length || typeof hexColor !== 'string') {
                return defaultColor();
            }
            if (hexColor[0] === '#') {
                hexColor = hexColor.slice(1);
            }
            // Convert "FED" to "FFEEDD"
            if (hexColor.length === 3) {
                hexColor =
                    hexColor[0] +
                    hexColor[0] +
                    hexColor[1] +
                    hexColor[1] +
                    hexColor[2] +
                    hexColor[2];
            }
            if (hexColor.length !== 6) {
                return defaultColor();
            }

            var r = parseInt(hexColor.slice(0, 2), 16);
            var g = parseInt(hexColor.slice(2, 4), 16);
            var b = parseInt(hexColor.slice(4, 6), 16);
            return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
        },
        // Colors Dialog
        openColorsDialog() {
            this.colorsDialog = true;
        },
        openMapLayersDialog() {
            this.layersDialog = true;
        },
        async ApplyColors() {
            await this.updateMapColors();
        },
        async updateMapColors() {
            // Save user options
            let options = [];
            options.push(['UI:TICKET_COLOR_ADDRESS', this.addressColor]);
            options.push(['UI:TICKET_COLOR_BESTFIT', this.bestfitColor]);
            options.push(['UI:TICKET_COLOR_DIGSITE', this.digSiteColor]);
            options.push(['UI:TICKET_COLOR_GRID', this.gridColor]);
            options.push(['UI:TICKET_COLOR_PARCEL', this.parcelColor]);

            // Save options to backend via store action
            await this.$store.dispatch('updateUserOptions', options);

            this.digSiteColor = getOption('UI:TICKET_COLOR_DIGSITE');
            this.gridColor = getOption('UI:TICKET_COLOR_GRID');
            this.bestfitColor = getOption('UI:TICKET_COLOR_BESTFIT');
            this.addressColor = getOption('UI:TICKET_COLOR_ADDRESS');
            this.parcelColor = getOption('UI:TICKET_COLOR_PARCEL');

            this.colorsDialog = false;
        },
        // Layers Dialog
        async ApplyLayers() {
            await this.getLayerData();
            await this.AddChips();
            // this.renderView();
            if (this.defaultCheckbox) this.saveLayerOptions();
            this.layersDialog = false;
        },
        async getLayerData() {
            // clear layer features, and if none checked or too far out then leave
            let curZoom = this.qm.getMapZoom();
            if (!this.layerCheckbox.length || curZoom < this.MIN_ZOOM_FOR_MAP_LAYER_DATA) {
                return;
            }
            let currentMapExtent = this.qm.getMapExtentObj();
            if(__LAST_MAP_EXTENT) {
                // is currentMapExtent contained in __LAST_MAP_EXTENT?
                if(currentMapExtent.left > __LAST_MAP_EXTENT.left &&
                   currentMapExtent.right < __LAST_MAP_EXTENT.right &&
                   currentMapExtent.top < __LAST_MAP_EXTENT.top &&
                   currentMapExtent.bottom > __LAST_MAP_EXTENT.bottom) {
                    // we have the data we need, so we are done
                    return;
                }
            }
            __LAST_MAP_EXTENT = currentMapExtent;

            // get layer data from backend via store action
            let response = await webtmsBackend.getLayerData(this.layerCheckbox, currentMapExtent);

            // add layer features to map
            const features = {
                type: 'FeatureCollection',
                features: [],
            };
            for (var i = 0; i < response.info.layers.length; i++) {
                // get layer name and style
                const layer_id = response.info.layers[i];
                let name = '';
                let show = true;
                let color = '#808080';
                for (const companyLayer of this.companyLayersVisible){
                    name = companyLayer.name;
                    let style= companyLayer.style;
                    if (guidEqual(companyLayer.layer_id, layer_id)){
                        show = style.show;
                        color = style.color;
                        break;
                    }
                }
                if(color.length > 7 && color.startsWith('#')) { 
                    color = color.substring(0,7); 
                }
                const strokeColor = this.hexToRGBA(color,1);
                const fillColor = this.hexToRGBA(color,0.2);
                // get shape data a layer features
                for (const shape of response.data[i]){
                    features.features.push({
                        type: 'Feature',
                        properties: {
                            group:'layer',
                            layer_id: layer_id,
                            show: show,
                            style: function(zoom){
                                return zoom<0?undefined:new Style({
                                    text:new Text({text:zoom<14?'':name,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:-15}),
                                    stroke:new Stroke({color:strokeColor,width:2}),
                                    fill:new Fill({color:fillColor}),
                                });
                            },
                        },
                        geometry: {
                            type: 'Polygon',
                            coordinates: JSON.parse(`[[[${shape[1].replace(/,-/g,'],[-')}]]]`)
                        }
                    });
                }
            }
            this.qm.removeFromShow('group','layer');
            this.qm.addToShow(features);
        },
        async AddChips() {
            this.layerChips = [];
            for (let i = 0; i < this.layerCheckbox.length; i++) {
                for (const j of this.companyLayersVisible) {
                    if (guidEqual(this.layerCheckbox[i],j.layer_id)) {
                        this.layerChips.push({
                            name: j.name,
                            layer_id: j.layer_id,
                            external_layer_json: j.external_layer_json,
                            style: j.style
                        });
                        if(j.external_layer_json.length) {
                            console.log('AddChips::external_layer_json', j.external_layer_json);
                            let layer = JSON.parse(j.external_layer_json);
                            await this.addEsriFeatureLayer(
                                this.qm,
                                layer.url,
                                layer.apiKey,
                                j.style.color,
                                layer.label
                            );
                        }
                    }
                }
            }
        },
        removeLayer(layerIndex) {
            // remove layer from features
            if(this.layerChips[layerIndex].external_layer_json.length) {
                let name = JSON.parse(this.layerChips[layerIndex].external_layer_json).url;
                this.removeEsriFeatureLayer(this.qm, name);
            } else {
                this.qm.removeFromShow('layer_id', this.layerChips[layerIndex].layer_id);
            }

            // remove checkbox
            for (let i = 0; i < this.layerCheckbox.length; i++) {
                if (
                    this.layerCheckbox[i] ===
                    this.layerChips[layerIndex].layer_id
                ) {
                    this.layerCheckbox.splice(i, 1);
                    break;
                }
            }
            /*  */
            // remove chip
            this.layerChips.splice(layerIndex, 1);
        },
        clearLayers() {
            this.qm.removeFromShow('group', 'layer');
            // remove Esri layers
            for (let i = 0; i < this.layerChips.length; i++) {
                if(this.layerChips[i].external_layer_json.length) {
                    let name = JSON.parse(this.layerChips[i].external_layer_json).url;
                    this.removeEsriFeatureLayer(this.qm, name);
                }
            }
            this.layerCheckbox = [];
            this.layerChips = [];
            this.qm.map.renderSync();

        },
        async saveLayerOptions() {
            // data to save for user
            let layers = [];
            for (const chip of this.layerChips) {
                layers.push(chip.layer_id);
            }

            // Save options to backend via store action
            const options = [['MAP_LAYERS_SHOW_DEFAULT', layers.join()]];
            await this.$store.dispatch('updateUserOptions', options);
        },
        async singleClick(data){
            const click=data.detail;
            if (click.type === 'identify'){

                let data = await webtmsBackend.fetchReverseStreet(
                    this.state,
                    this.county,
                    click.coordinate[1],
                    click.coordinate[0],
                    1000);
                const strokeColor=this.hexToRGBA('#bc2bbc',1);
                if (data.allofclosest){
                    const features = {
                        type: 'FeatureCollection',
                        features: [],
                    };
                    for (const line of data.allofclosest){
                        features.features.push({
                            type: 'Feature',
                            properties: {
                                group: 'identify',
                                style: function(zoom){
                                    return zoom<0?undefined:new Style({
                                        text:new Text({text:zoom<14?'':`${line.from}-${line.to}`,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:-15}),
                                        stroke:new Stroke({color:strokeColor,width:5}),
                                    });
                                },
                            },
                            geometry: {
                                type: 'LineString',
                                coordinates: JSON.parse(`[[${line.pointstring.replace(/,-/g,'],[-')}]]`)
                            }
                        });
                    }
                    this.qm.removeFromShow('group','identify');
                    this.qm.addToShow(features);
                }
            }
        },
        async addressParcel(which) {
            const features = {
                type: 'FeatureCollection',
                features: [],
            };

            if (which === 'addr' && !this.renderAddress && this.mapDir.address.layer){
                const data = await webtmsBackend.fetchAddressPoints(
                    this.state,
                    this.county,
                    this.mapDir.address.layer,
                    'addr_numb:addr_full',
                    this.qm.getMapExtentObj()
                );
                // add address points
                const points = data.substring(3).replace(/,1:/g,'').split(';');
                for (const point of points) {
                    const point_data = point.split(',')[0];
                    const addr = point_data.split(':')[1];
                    const addr_full = point_data.split(':')[2];
                    const color=this.hexToRGBA(this.addressColor,1);
                    features.features.push({
                        type: 'Feature',
                        properties: {
                            group: 'address',
                            style: function(zoom){
                                return zoom<14?undefined:new Style({
                                    text:new Text({text:zoom<16?'':zoom<18?addr:addr_full,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:-15}),
                                    image:new Circle({stroke:new Stroke({color:'black',width:2}),fill:new Fill({color:color}),radius:5}),
                                });
                            },
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: JSON.parse(`[${point.split(',')[1] + ',' + point.split(',')[2]}]`)
                        }
                    });
                }
            }else if(which === 'parcel' && !this.renderParcel && this.mapDir.parcel.layer){
                const data = await webtmsBackend.fetchParcels(
                    this.state,
                    this.county,
                    this.mapDir.parcel.layer,
                    this.qm.getMapExtentObj()
                );
                const polygons = data.substring(3).replace(/,5:/g,'').split(';');
                for (const polygon of polygons) {
                    const polygon_data = polygon.split(',')[0];
                    const addr = polygon_data.split(':')[1];
                    const addr_full = polygon_data.split(':')[2];
                    const parts = polygon.substring(polygon.indexOf(',')).split(':');
                    const strokeColor=this.hexToRGBA(this.parcelColor,1);
                    const fillColor=this.hexToRGBA(this.parcelColor,0.1);
                    for (const part of parts){
                        features.features.push({
                            type:'Feature',
                            properties:{
                                group:'parcel',
                                style: function(zoom){
                                    return zoom<14?undefined:new Style({
                                        text:new Text({text:zoom<16?'':zoom<18?addr:addr_full,font:'bold 12px Calibri,sans-serif',stroke:new Stroke({color:'white',width:3}),fill:new Fill({color:'black'}),offsetY:-15}),
                                        stroke:new Stroke({color:strokeColor,width:2}),
                                        fill:new Fill({color:fillColor}),
                                    });
                                },
                            },
                            geometry: {
                                type: 'Polygon',
                                coordinates: JSON.parse(`[[[${part.substring(part.indexOf(',')+1).replace(/,-/g,'],[-')}]]]`)
                            }
                        });
                    }
                }
            }
            this.qm.removeFromShow('group','address');
            this.qm.removeFromShow('group','parcel');
            this.qm.addToShow(features);
        },
        openGoogleMaps() {
            let queryAddress = `${this.ticketDetails.Tickets.address_label} ${this.ticketDetails.Tickets.zip ? this.ticketDetails.Tickets.zip : ''}`;
            if (queryAddress && queryAddress.length) {
                window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(queryAddress)}`, '_blank');
            } else {
                alert('No coordinates available for this ticket.');
            }
        },
        initializeMapOptions() {
            if(this.renderGrids) { this.loadGrids(); }
            if(this.renderWorkArea) { this.loadWorkArea(); }
            if(this.renderBoundingBox) { this.loadExtent(); }
        },
    },
};
</script>

<style>
p, label {
    font: 1rem "Fira Sans", sans-serif;
}
.configColors {
    -webkit-text-size-adjust: 100%;
    text-shadow: 0 /*{c-body-shadow-x}*/ 1px /*{c-body-shadow-y}*/ 0
        /*{c-body-shadow-radius}*/ #fff /*{c-body-shadow-color}*/;
    font-family: Helvetica, Arial, sans-serif /*{global-font-family}*/;
    min-height: 1.4em;
    line-height: 1.4em;
    font-size: 16px;
    -webkit-appearance: none;
    border: none;
    padding: 0.4em 0;
    margin: 0;
    display: block;
    background: transparent none;
    outline: 0 !important;
    width: 100%;
}
.colorBtn {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    border: 1px solid #aaa /*{c-body-border}*/;
    color: #333 /*{c-body-color}*/;
    text-shadow: 0 /*{c-body-shadow-x}*/ 1px /*{c-body-shadow-y}*/ 0
        /*{c-body-shadow-radius}*/ #fff /*{c-body-shadow-color}*/;
    background: #f9f9f9 /*{c-body-background-color}*/;
    font-family: Helvetica, Arial, sans-serif /*{global-font-family}*/;
    border-radius: 0.6em /*{global-radii-blocks}*/;
    background-clip: padding-box;
    box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.2);
    margin: 0.5em 0;
    background-image: none;
    position: relative;
    padding: 0 0.4em;
}
.layerDialogText {
    font-size: 1.2rem;
    font-weight: bold;
}
.layerDialogColor {
    width: 1.5rem;
    height: 1.5rem;
}
.layer-chips {
    margin-bottom: 5px;
}
.mobile-icons {
    position: absolute;
    top: 25px;
    right: 25px;
    z-index: 10;
}
</style>
